import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
type CardGridProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Two cards to a row once the nearest `@container` is wide enough; an odd last card takes the whole row. Cards stretch
 * to their row, so one with `flex flex-col` and a `flex-1` body ends level with a longer neighbor.
 */
const CardGrid = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("grid grid-cols-1 gap-3 @3xl:grid-cols-2 @3xl:[&>*:last-child:nth-child(odd)]:col-span-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default CardGrid;